<template>
  <div id="main-gn">
    <div class="main-header">
      <span class="main-title">我们能做什么?</span>
      <span class="main-text">致力于快速满足客户需求,为客户创造最大价值而服务</span>
    </div>
    <div class="main">
      <div class="left">
        <div :class="itemId==1?'new-left-item':'left-item'" @click="itemId=1">
          <span>01</span>
          <div class="left-item-text">
            <span>FGZW光伏电站</span>
            <span>监控系统</span>
          </div>
        </div>
        <div :class="itemId==2?'new-left-item':'left-item'" @click="itemId=2">
          <span>02</span>
          <div class="left-item-text">
            <span>FGZW光伏电站</span>
            <span>智慧分析云平台</span>
          </div>
        </div>
        <div :class="itemId==3?'new-left-item':'left-item'" @click="itemId=3">
          <span>03</span>
          <div class="left-item-text">
            <span>FGZW光伏电站</span>
            <span>数据采集软件</span>
          </div>
        </div>
        <div :class="itemId==4?'new-left-item':'left-item'" @click="itemId=4">
          <span>04</span>
          <div class="left-item-text">
            <span>光伏</span>
            <span>扶贫集中监管云平台</span>
          </div>
        </div>
        <div :class="itemId==5?'new-left-item':'left-item'" @click="itemId=5">
          <span>05</span>
          <div class="left-item-text">
            <span>一</span>
            <span>智能通讯管理机</span>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="right-title">
          <span class="title">FGZW光伏电站监控系统</span>
          <span class="text">监控系统为光伏电站的核心系统,伏云科技根据光伏发电行业的发展及特点,通过自主研发的通讯管理机系列智能化硬件为基础,充分利用数据分析及数据挖掘等智能化手段,提供智能化的光伏电站监控系统。产品包含光伏设备数据监控及视频监控,服务于分布式光伏电站。</span>
        </div>
        <div class="img">
          <img v-if="itemId==1" :src=gn1Png alt="">
          <img v-if="itemId==2" :src=gn2Png alt="">
          <img v-if="itemId==3" :src=gn3Png alt="">
          <img v-if="itemId==4" :src=gn4Png alt="">
          <img v-if="itemId==5" :src=gn5Png alt="">
        </div>
      </div>
    </div>

  </div>

</template>

<script>
import gn1Png from '@/assets/image/gn1.png'
import gn2Png from '@/assets/image/gn2.png'
import gn3Png from '@/assets/image/gn3.png'
import gn4Png from '@/assets/image/gn4.png'
import gn5Png from '@/assets/image/gn5.png'
export default {
  name: "GnPage",
  data(){
    return{
      gn1Png,gn3Png,gn4Png,gn5Png,gn2Png,
      itemId:1,
    }
  }
}
</script>

<style lang="scss" scoped>
#main-gn{
  width: 60%;
  display: flex;
  flex-direction: column;
  padding-bottom: 100px;
  .main-header{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 64px;
    padding-bottom: 48px;
    .main-title{
      font-family: 'PingFang SC';
      font-weight: 600;
      font-size: 28px;
      color: #031222;
      padding-bottom: 12px;
    }
    .main-text{
      font-family: 'PingFang SC';
      font-weight: 500;
      font-size: 14px;
      color: rgba(3, 18, 34, 0.4);
    }
  }
}
.main{
  width: 100%;
  display: flex;
  gap: 40px;
  .new-left-item{
    display: flex;
    align-items: center;
    gap: 12px;
    width: 288px;
    height: 106px;
    padding-left: 32px;
    cursor: pointer;
    background: #1187FF;
    border-radius: 4px;
    box-shadow: 0px 4px 8px rgba(17, 135, 255, 0.5);
    >span{
      font-family: 'FF DIN Pro';
      font-weight: 700;
      font-size: 32px;
      color: #FFFFFF;
    }
    .left-item-text{
      display: flex;
      flex-direction: column;
      font-family: 'PingFang SC';
      font-weight: 500;
      font-size: 14px;
      color: #FFFFFF;
    }
  }
  .left-item{
    display: flex;
    align-items: center;
    gap: 12px;
    width: 288px;
    height: 106px;
    border-bottom: 1px dashed rgba(3, 18, 34, 0.3);
    padding-left: 32px;
    cursor: pointer;
    >span{
      font-family: 'FF DIN Pro';
      font-weight: 700;
      font-size: 32px;
      color: rgba(3, 18, 34, 0.7);
    }
    .left-item-text{
      display: flex;
      flex-direction: column;
      font-family: 'PingFang SC';
      font-weight: 500;
      font-size: 14px;
      color: rgba(3, 18, 34, 0.7);
    }
  }
  .right{
    display: flex;
    flex-direction: column;
    padding: 36px 0 38px 0;
    gap: 32px;
    .right-title{
      display: flex;
      flex-direction: column;
      gap: 12px;
      .title{
        font-family: 'PingFang SC';
        font-weight: 500;
        font-size: 24px;
        color: #031222;
      }
      .text{
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 14px;
        line-height: 26px;
        color: rgba(3, 18, 34, 0.7);
        letter-spacing: 0.5px;
      }
    }
    .img{
      display: flex;
      justify-content: center;
      img{
        width: 600px;
        height: 338px;
      }
    }
  }
}
</style>